import api from '@/api/api';

const state = {
  table: {},
  tableData: {}
};

const mutations = {
  GET_TABLE: (state, data) => {
    const { table_data, ...rest } = data;
    state.tableData = table_data;
    state.table = { ...rest };
  }
};

const actions = {
  getTableData: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .getTable(id)
        .then(response => {
          commit('GET_TABLE', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
          console.error(err);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
